module.exports = __webpack_public_path__ + "media/images/credit_cards/credit_card-b948b4ae1269e4f5526dc77178f9a857.gif";